import styled from '@emotion/styled';
import { gsap } from 'gsap';
import { useState, useLayoutEffect, useRef } from 'react';

import { animateSVGPath } from '@components/Sections/utils/animations';
import { PenLine } from '@features';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const TitlePenUnderline: React.FC = () => {
  const [titlePenUnderlinePathLength, setTitlePenUnderlinePathLength] = useState(0);
  const titlePenUnderlineRef = useRef<SVGPathElement | null>(null);

  useLayoutEffect(() => {
    const titlePenUnderlineEl = titlePenUnderlineRef.current;

    if (!titlePenUnderlineEl) {
      return;
    }

    const ctx = gsap.context(() => {
      const penPathLength = titlePenUnderlineEl.getTotalLength();
      setTitlePenUnderlinePathLength(penPathLength);
      animateSVGPath({
        animationTarget: titlePenUnderlineEl,
        animationTrigger: titlePenUnderlineEl,
        animationStartPositions: 'top 35%',
        pathLength: penPathLength,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <PenUnderline width="391" height="9" viewBox="0 0 391 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.82668 2.07055C10.1479 1.9253 18.4969 1.60202 26.8165 1.67113C37.4889 1.75979 48.0143 3.25083 58.672 3.0648C76.3518 2.7562 93.8034 5.76241 111.422 5.45487C122.729 5.2575 133.92 6.41608 145.197 6.85182C158.972 7.38409 172.689 7.03412 186.483 6.79334C208.115 6.41575 229.822 6.69902 251.494 6.32073C297.646 5.51515 343.772 6.03435 389.941 5.22847"
        stroke="#D9FC51"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray={`${titlePenUnderlinePathLength} ${titlePenUnderlinePathLength}`}
        ref={titlePenUnderlineRef}
      />
    </PenUnderline>
  );
};

const PenUnderline = styled(PenLine)`
  ${getMediaqueryStyled('xl')} {
    width: 286px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 210px;
  }

  ${getMediaqueryStyled('sm')} {
    display: none;
  }
`;
